import { red } from '@material-ui/core/colors';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const baseTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#10375c',
        },
        secondary: {
            main: '#855600',
            light: '#f2bd56',
            contrastText: '#ffffff',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#f3f6fb',
            paper: '#ffffff',
        },
        text: {
            primary: '#0b1d2c',
            secondary: '#4a5b6a',
        }
    },
    shape: {
        borderRadius: 18,
    },
    typography: {
        fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif',
        h1: {
            fontWeight: 700,
            letterSpacing: '-0.02em',
        },
        h2: {
            fontWeight: 600,
        },
        h3: {
            fontWeight: 600,
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
        }
    },
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 999,
            }
        },
        MuiPaper: {
            rounded: {
                borderRadius: 18,
            }
        }
    }
});

const theme = responsiveFontSizes(baseTheme);

export default theme;
